<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>
        <span v-if="$route.params.scrap_type == 1">网站</span>
        <span v-if="$route.params.scrap_type == 2">接口</span>期间设置
      </el-breadcrumb-item>
    </el-breadcrumb>
    <h1 class="view-head">
      <span v-if="$route.params.scrap_type == 1">网站</span>
      <span v-if="$route.params.scrap_type == 2">接口</span>期间设置
    </h1>
    <div class="view-content">
      <el-tabs type="border-card" v-model="schemeType">
        <el-tab-pane label="日报" value="0" v-if="(scrap_type == 1 && $store.state.funcModuleArray.includes(1901020201)) || (scrap_type == 2 && $store.state.funcModuleArray.includes(1901020301))">
          <el-form ref="form0" :model="form0" label-width="100px">
            <el-card class="box-card">
              <div class="card-content">
                <el-form-item label="报告时间段" class="wipe-mb">
                  <span>每月1号到昨天的数据</span>
                </el-form-item>
              </div>
            </el-card>
            <el-card class="box-card">
              <div class="card-content">
                <el-form-item label="报告生成日期" class="wipe-mb">
                  <span>每天</span>
                  <el-input
                    v-model="form0.reportTime.hour"
                    class="time-input"
                  ></el-input>
                  <span>时</span>
                  <el-input
                    v-model="form0.reportTime.minute"
                    class="time-input"
                  ></el-input>
                  <span>分</span>
                </el-form-item>
              </div>
            </el-card>
            <el-form-item class="no-lable">
              <el-button
                type="primary"
                @click="onSubmit('form0')"
                :loading="isLoading"
                >保存</el-button
              >
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="周报" value="2" v-if="(scrap_type == 1 && $store.state.funcModuleArray.includes(1901020202)) || (scrap_type == 2 && $store.state.funcModuleArray.includes(1901020302))">
          <el-form ref="form2" :model="form2" label-width="140px">
            <el-card class="box-card">
              <div class="card-content">
                <el-form-item label="周报数据抓取范围">
                  <el-radio-group v-model="form2.reportTime.exec_type">
                    <el-radio :label="1">自定义范围</el-radio>
                    <el-radio :label="2">每月1号到昨天</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item
                  label="报告开始日期"
                  v-if="form2.reportTime.exec_type != 2"
                >
                  <span>每周第</span>
                  <el-input
                    v-model="form2.startTime.day"
                    class="time-input"
                  ></el-input>
                  <span>日</span>
                </el-form-item>

                <el-form-item
                  label="报告截止日期"
                  class="wipe-mb"
                  v-if="form2.reportTime.exec_type != 2"
                >
                  <span>次周第</span>
                  <el-input
                    v-model="form2.endTime.day"
                    class="time-input"
                  ></el-input>
                  <span>日</span>
                </el-form-item>
              </div>
            </el-card>
            <el-card class="box-card">
              <div class="card-content">
                <el-form-item label="报告生成日期" class="wipe-mb">
                  <span>每周</span>
                  <el-input
                    v-model="form2.reportTime.day"
                    class="time-input"
                  ></el-input>
                  <span>日</span>
                  <el-input
                    v-model="form2.reportTime.hour"
                    class="time-input"
                  ></el-input>
                  <span>时</span>
                  <el-input
                    v-model="form2.reportTime.minute"
                    class="time-input"
                  ></el-input>
                  <span>分</span>
                  <span class="space">生成</span>
                  <span>前</span>
                  <el-input
                    v-model="form2.reportTime.week"
                    class="time-input"
                  ></el-input>
                  <span>周的数据</span>
                </el-form-item>
              </div>
            </el-card>
            <el-form-item class="no-lable">
              <el-button
                type="primary"
                @click="onSubmit('form2')"
                :loading="isLoading"
                >保存</el-button
              >
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="月报" value="1" v-if="(scrap_type == 1 && $store.state.funcModuleArray.includes(1901020203)) || (scrap_type == 2 && $store.state.funcModuleArray.includes(1901020303))">
          <el-form ref="form1" :model="form1" label-width="100px">
            <!--            <el-card class="box-card">-->
            <!--              <div class="card-content">-->
            <!--                <el-form-item label="报告开始日期">-->
            <!--                  <span>每月第</span>-->
            <!--                  <el-input v-model="form1.startTime.day" class="time-input"></el-input>-->
            <!--                  <span>日</span>-->
            <!--                </el-form-item>-->

            <!--                <el-form-item label="报告截止日期" class="wipe-mb">-->
            <!--                  <span>次月第</span>-->
            <!--                  <el-input v-model="form1.endTime.day" class="time-input"></el-input>-->
            <!--                  <span>日</span>-->
            <!--                </el-form-item>-->
            <!--              </div>-->
            <!--            </el-card>-->
            <el-card class="box-card">
              <div class="card-content">
                <el-form-item label="报告时间段" class="wipe-mb">
                  <span>上月整月数据</span>
                </el-form-item>
              </div>
            </el-card>
            <el-card class="box-card">
              <div class="card-content">
                <el-form-item label="报告生成日期" class="wipe-mb">
                  <span>每月</span>
                  <!--                  <span>次</span>-->
                  <!--                  <el-input v-model="form1.reportTime.month" class="time-input"></el-input>-->
                  <!--                  <span>月</span>-->
                  <el-input
                    v-model="form1.reportTime.day"
                    class="time-input"
                  ></el-input>
                  <span>日</span>
                  <el-input
                    v-model="form1.reportTime.hour"
                    class="time-input"
                  ></el-input>
                  <span>时</span>
                  <el-input
                    v-model="form1.reportTime.minute"
                    class="time-input"
                  ></el-input>
                  <span>分</span>
                </el-form-item>
              </div>
            </el-card>
            <el-form-item class="no-lable">
              <el-button
                type="primary"
                @click="onSubmit('form1')"
                :loading="isLoading"
                >保存</el-button
              >
            </el-form-item>
          </el-form>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import { getWebScrapPeriod, setWebScrapPeriod } from "@/api/index";

export default {
  name: "webPeriodSet",
  data: () => ({
    isLoading: false,
    schemeType: "0",
    form0: {
      reportTime: {
        hour: "",
        minute: ""
      }
    },
    form1: {
      // startTime: {
      //   day: ''
      // },
      // endTime: {
      //   day: ''
      // },
      reportTime: {
        // month: '',
        day: "",
        hour: "",
        minute: ""
      }
    },
    form2: {
      startTime: {
        day: ""
      },
      endTime: {
        day: ""
      },
      reportTime: {
        week: "",
        day: "",
        hour: "",
        minute: "",
        exec_type: 1
      }
    }
  }),
  created() {
    let params = {
      scrap_type: this.$route.params.scrap_type
    };
    getWebScrapPeriod(params).then(res => {
      if (0 === res.status) {
        let data = res.data;
        if (data.length == 0) {
          return;
        }
        for (let item of data) {
          // let start_time = JSON.parse(item.start_time);
          // let end_time = JSON.parse(item.end_time);
          let exec_time = JSON.parse(item.exec_time);
          let end_time = JSON.parse(item.end_time);
          let start_time = JSON.parse(item.start_time);
          switch (item.period_type) {
            case 0:
              this["form" + item.period_type] = {
                reportTime: {
                  hour: exec_time.hour,
                  minute: exec_time.min
                }
              };
              break;
            case 1:
              this["form" + item.period_type] = {
                // startTime: {
                //   day: start_time.day
                // },
                // endTime: {
                //   day: end_time.day
                // },
                reportTime: {
                  // month: exec_time.month,
                  day: exec_time.day,
                  hour: exec_time.hour,
                  minute: exec_time.min
                }
              };
              break;
            case 2:
              this["form" + item.period_type] = {
                startTime: {
                  day: start_time.day
                },
                endTime: {
                  day: end_time.day
                },
                reportTime: {
                  exec_type: exec_time.exec_type != 2 ? 1 : exec_time.exec_type,
                  week: exec_time.week,
                  day: exec_time.day,
                  hour: exec_time.hour,
                  minute: exec_time.minute
                }
              };
              break;
          }
        }
      }
    });
  },
  computed:{
    scrap_type(){
      return this.$route.params.scrap_type
    }
  },
  methods: {
    onSubmit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          const decideNumber = /^\d+$/;
          let values = { ...this[formName] };
          let reportTime = values.reportTime;
          let period_type = this.schemeType;
          console.log(period_type);
          switch (period_type) {
            case "0":
              for (let i in values.reportTime) {
                switch (i) {
                  case "hour":
                    let temp2 = parseInt(values.reportTime[i]);
                    if (
                      temp2 > 23 ||
                      temp2 < 0 ||
                      values.reportTime[i] === "" ||
                      !decideNumber.test(values.reportTime[i])
                    ) {
                      this.$message.error(
                        "请正确填写报告生成日期,【时】范围0～23"
                      );
                      return;
                    }
                    break;
                  case "minute":
                    let temp3 = parseInt(values.reportTime[i]);
                    if (
                      temp3 > 59 ||
                      temp3 < 0 ||
                      values.reportTime[i] === "" ||
                      !decideNumber.test(values.reportTime[i])
                    ) {
                      this.$message.error(
                        "请正确填写报告生成日期,【分】范围0～59"
                      );
                      return;
                    }
                    break;
                }
              }
              break;
            case "1":
              let tempStartDay = parseInt(values.startTime.day);
              let tempEndDay = parseInt(values.endTime.day);
              console.log(tempStartDay);
              console.log(values);
              if (values.reportTime.exec_type == 1) {
                //开始 天
                if (tempStartDay === "" || !tempStartDay) {
                  this.$message.error("请正确填写开始日期");
                  return;
                } else {
                  if (
                    tempStartDay === "1" &&
                    (tempStartDay > 7 || tempStartDay < 1)
                  ) {
                    this.$message.error("请正确填写开始日期,【日】范围1～7");
                    return;
                  }
                }
                //结束 天
                if (tempEndDay === "" || !tempEndDay) {
                  this.$message.error("请正确填写截止日期");
                  return;
                } else {
                  if (
                    tempEndDay === "1" &&
                    (tempEndDay > 7 || tempEndDay < 1)
                  ) {
                    this.$message.error("请正确填写截止日期,【日】范围1～7");
                    return;
                  }
                }
              }
              //生成报告 日期
              for (let i in reportTime) {
                switch (i) {
                  case "day":
                    let temp = parseInt(reportTime[i]);
                    if (
                      reportTime[i] === "" ||
                      !decideNumber.test(reportTime[i])
                    ) {
                      this.$message.error("请正确填写报告生成日期");
                      return;
                    } else {
                      // 周报
                      if (period_type === "1" && (temp > 7 || temp < 1)) {
                        this.$message.error(
                          "请正确填写报告生成日期,【日】范围1～7"
                        );
                        return;
                      }
                    }
                    break;
                  case "hour":
                    let temp2 = parseInt(reportTime[i]);
                    if (
                      temp2 > 23 ||
                      temp2 < 0 ||
                      reportTime[i] === "" ||
                      !decideNumber.test(reportTime[i])
                    ) {
                      this.$message.error(
                        "请正确填写报告生成日期,【时】范围0～23"
                      );
                      return;
                    }
                    break;
                  case "minute":
                    let temp3 = parseInt(reportTime[i]);
                    if (
                      temp3 > 59 ||
                      temp3 < 0 ||
                      reportTime[i] === "" ||
                      !decideNumber.test(reportTime[i])
                    ) {
                      this.$message.error(
                        "请正确填写报告生成日期,【分】范围0～59"
                      );
                      return;
                    }
                    break;
                  // case 'month':
                  //   let temp4 = parseInt(reportTime[i]);
                  //   if (reportTime[i] === '' || !decideNumber.test(reportTime[i])) {
                  //     this.$message.error('请正确填写报告生成日期');
                  //     return;
                  //   } else if (period_type === '2' && (temp4 > 999)) {
                  //     this.$message.error('请正确填写报告生成日期,【月】范围0～999');
                  //     return;
                  //   }
                  //   break;
                  case "week":
                    let temp5 = parseInt(reportTime[i]);
                    if (
                      reportTime[i] === "" ||
                      !decideNumber.test(reportTime[i])
                    ) {
                      this.$message.error("请正确填写报告生成日期");
                      return;
                    } else if (period_type === "1" && temp5 > 999) {
                      this.$message.error(
                        "请正确填写报告生成日期,【周】范围0～999"
                      );
                      return;
                    }
                    break;
                }
              }

              break;
            case "2":
              // let startTimeDay = parseInt(values.startTime.day);
              // if (startTimeDay > 31 || startTimeDay < 1 || values.startTime.day === '' || !decideNumber.test(values.startTime.day)) {
              //   this.$message.error('请正确填写报告开始日期,【日】范围1～31');
              //   return;
              // }
              // let endTimeDay = parseInt(values.endTime.day);
              // if (endTimeDay > 31 || values.endTime.day < 1 || values.endTime.day === '' || !decideNumber.test(values.endTime.day)) {
              //   this.$message.error('请正确填写报告截止日期,【日】范围1～31');
              //   return;
              // }
              for (let i in values.reportTime) {
                switch (i) {
                  case "day":
                    let temp = parseInt(values.reportTime[i]);
                    if (
                      temp > 31 ||
                      temp < 1 ||
                      values.reportTime[i] === "" ||
                      !decideNumber.test(values.reportTime[i])
                    ) {
                      this.$message.error(
                        "请正确填写报告生成日期,【日】范围1～31"
                      );
                      return;
                    }
                    break;
                  case "hour":
                    let temp2 = parseInt(values.reportTime[i]);
                    if (
                      temp2 > 23 ||
                      temp2 < 0 ||
                      values.reportTime[i] === "" ||
                      !decideNumber.test(values.reportTime[i])
                    ) {
                      this.$message.error(
                        "请正确填写报告生成日期,【时】范围0～23"
                      );
                      return;
                    }
                    break;
                  case "minute":
                    let temp3 = parseInt(values.reportTime[i]);
                    if (
                      temp3 > 59 ||
                      temp3 < 0 ||
                      values.reportTime[i] === "" ||
                      !decideNumber.test(values.reportTime[i])
                    ) {
                      this.$message.error(
                        "请正确填写报告生成日期,【分】范围0～59"
                      );
                      return;
                    }
                    break;
                  case "month":
                    let temp4 = parseInt(values.reportTime[i]);
                    if (
                      values.reportTime[i] === "" ||
                      !decideNumber.test(values.reportTime[i])
                    ) {
                      this.$message.error("请正确填写报告生成日期");
                      return;
                    } else if (temp4 > 999) {
                      this.$message.error(
                        "请正确填写报告生成日期,【月】范围0～999"
                      );
                      return;
                    }
                    break;
                  // case 'week':
                  //   let temp5 = parseInt(values.reportTime[i]);
                  //   if (temp5 === '' || !decideNumber.test(temp5)) {
                  //     this.$message.error('请正确填写报告生成日期');
                  //     return;
                  //   }
                  //   break;
                }
              }
              break;
          }
          let finalData = {};
          switch (period_type) {
            case "0":
              let exec_time = {
                hour: values.reportTime.hour,
                min: values.reportTime.minute
              };
              finalData = { exec_time: JSON.stringify(exec_time) };
              break;
            case "1":
              let startTime = values.startTime;
              let endTime = values.endTime;
              let start_time = {
                day: startTime.day
              };

              let end_time = {
                day: endTime.day
              };

              let exec_time1 = {
                day: reportTime.day,
                hour: reportTime.hour,
                minute: reportTime.minute,
                week: reportTime.week,
                exec_type: reportTime.exec_type
              };
              start_time = JSON.stringify(start_time);
              end_time = JSON.stringify(end_time);
              exec_time = JSON.stringify(exec_time1);
              finalData = { start_time, end_time, exec_time };
              break;
            case "2":
              // let start_time = {
              //   day: values.startTime.day
              // };
              //
              // let end_time = {
              //   day: values.endTime.day
              // };

              let exec_time2 = {
                // month: values.reportTime.month,
                day: values.reportTime.day,
                hour: values.reportTime.hour,
                min: values.reportTime.minute
              };
              finalData = {
                // start_time: JSON.stringify(start_time),
                // end_time: JSON.stringify(end_time),
                exec_time: JSON.stringify(exec_time2)
              };
              break;
          }
          if (period_type == 1) {
            period_type = 2;
          } else if (period_type == 2) {
            period_type = 1;
          }
          finalData.period_type = period_type;
          finalData.scrap_type = this.$route.params.scrap_type;

          let params = {
            scrap_type: this.$route.params.scrap_type,
            data: JSON.stringify(finalData)
          };
          this.isLoading = true;
          setWebScrapPeriod(params).then(res => {
            this.isLoading = false;
            if (0 === res.status) {
              this.$message({
                message: res.msg,
                type: "success"
              });
            } else {
              this.$message.error(res.msg);
            }
          });
        }
      });
    }
  }
};
</script>

<style scoped lang="scss">
.box-card {
  margin-bottom: 20px;
}

.time-input {
  width: 50px;
  margin: 0 10px;
}
</style>
